import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchOpeningHours() {
  try {
    const openingHours = yield call(function() {
      return Api.get('/dealer/opening-hours');
    });
    yield put({type: 'FETCH_OPENING_HOURS.SUCCESS', openingHours})
  } catch (error) {
    yield put({type: 'FETCH_OPENING_HOURS.FAILURE', error})
  }
}

export function* watchFetchOpeningHours() {
  yield takeEvery('FETCH_OPENING_HOURS.REQUEST', fetchOpeningHours);
}

function* saveOpeningHours(action) {
  try {
    const openingHours = yield call(function () {
      return Api.post('/dealer/opening-hours', action.body);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'SAVE_OPENING_HOURS.SUCCESS', openingHours});
  } catch (error) {
    yield put({type: 'SAVE_OPENING_HOURS.FAILURE', error})
  }
}

export function* watchSaveOpeningHours() {
  yield takeEvery('SAVE_OPENING_HOURS.REQUEST', saveOpeningHours)
}
